module.exports = __webpack_public_path__ + "static/media/IMG_3607-min.3e21b0bf.JPG";